import css from 'styled-jsx/css';

const staticStyles = css.global``;

export { staticStyles };
